import React from 'react';
import { Button, FormField, HeaderTabsV2, AritoIcon } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface HeaderTabProps {
  mode: FormMode;
}
function HeaderTab({ mode }: HeaderTabProps) {
  return (
    <HeaderTabsV2
      tabs={[
        {
          id: 'info',
          label: 'Thông tin',
          component: (
            <div className='p-4'>
              <div className='flex flex-col gap-y-4 md:gap-y-6'>
                <div className='space-y-2 md:space-y-2'>
                  {/* Customer Code Field */}
                  <div className='flex items-center gap-2'>
                    <div className='flex flex-col sm:flex-row sm:items-center'>
                      <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã khách hàng</Label>
                      <FormField type='text' name='customer_code' disabled={mode === 'view'} />
                    </div>

                    <div className='flex flex-col gap-10 sm:flex-row sm:items-center'>
                      <div className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
                        <FormField
                          type='select'
                          name='customer_type'
                          defaultValue='doanh_nghiep'
                          options={[
                            { value: 'doanh_nghiep', label: 'Doanh nghiệp' },
                            { value: 'ca_nhan', label: 'Cá nhân' }
                          ]}
                        />
                      </div>
                      <div className='flex items-center gap-x-6'>
                        <div className='flex items-center gap-x-1'>
                          <FormField
                            type='checkbox'
                            id='is_customer'
                            name='is_customer'
                            defaultChecked={true}
                            disabled={true}
                            value={true}
                          />
                          <Label htmlFor='is_customer'>Khách hàng</Label>
                        </div>
                        <div className='flex items-center gap-x-1'>
                          <FormField
                            type='checkbox'
                            name='is_vendor'
                            id='is_vendor'
                            defaultChecked={true}
                            disabled={mode === 'view'}
                          />
                          <Label htmlFor='is_vendor'>Nhà cung cấp</Label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Customer Name Field */}
                  <div className='flex flex-col sm:flex-row sm:items-center'>
                    <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khách hàng</Label>
                    <FormField type='text' name='customer_name' disabled={mode === 'view'} />
                  </div>

                  {/* Alternative Name Field */}
                  <div className='flex flex-col sm:flex-row sm:items-center'>
                    <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khác</Label>
                    <FormField type='text' name='alternative_name' disabled={mode === 'view'} />
                  </div>

                  {/* Address Field */}
                  <div className='flex flex-col sm:flex-row sm:items-center'>
                    <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Địa chỉ</Label>
                    <FormField type='text' name='address' disabled={mode === 'view'} />
                  </div>

                  {/* Tax Code Field */}
                  <div className='flex items-center gap-2'>
                    <div className='flex flex-col sm:flex-row sm:items-center'>
                      <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã số thuế</Label>
                      <div className='flex items-center gap-x-2'>
                        <FormField type='text' name='tax_code' disabled={mode === 'view'} />
                        <Button
                          disabled={mode === 'view'}
                          className={
                            'flex h-8 w-8 items-center justify-center rounded border-gray-300 disabled:cursor-not-allowed disabled:opacity-50'
                          }
                        >
                          <AritoIcon icon={15} className='shrink-0' />
                        </Button>
                      </div>
                    </div>

                    {/* Contact Person Field */}
                    <div className='flex flex-col sm:flex-row sm:items-center'>
                      <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Người liên hệ</Label>
                      <FormField type='text' name='contact_person' disabled={mode === 'view'} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      ]}
    />
  );
}

export default HeaderTab;
